import React, {Component} from 'react';
import {Mobile, PC, Tablet} from "../../ReactiveMode";

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <PC>
                    <section className="footer-pc">
                        <div className="background">
                            <div className="company-info-area">
                                <img className="company-icon" src={process.env.PUBLIC_URL + '/images/logo.png'}></img>
                                <div className="company-info">
                                    <div className="address">(11601) 경기도 의정부시 입석로 24 (가능동, 성실교회)</div>
                                    <div className="telphone">031-877-5591</div>
                                    <div className="copyright">© 2024 SEONGSIL CHURCH. ALL RIGHTS RESERVED.</div>
                                </div>
                            </div>
                            <div className="url-info-area">

                            </div>
                        </div>
                    </section>
                </PC>
                <Tablet>
                    <section className="footer-tablet">
                        <div className="background">
                        </div>
                    </section>
                </Tablet>
                <Mobile>
                    <section className="footer-mobile" id="footer-mobile">
                        <div className="background">
                            <div className="company-info-area">
                                <img className="company-icon" src={process.env.PUBLIC_URL + '/images/logo.png'}></img>
                                <div className="company-info">
                                    <div className="address">(11601) 경기도 의정부시 입석로 24 (가능동, 성실교회)</div>
                                    <div className="telphone">031-877-5591</div>
                                    <div className="copyright">© 2024 SEONGSIL CHURCH. ALL RIGHTS RESERVED.</div>
                                </div>
                            </div>
                            <div className="url-info-area">

                            </div>
                        </div>
                    </section>
                </Mobile>
            </>
        )
    }
}

export default Footer;